//
// ThumbnailManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var ThumbnailManager = createModule("transport::ThumbnailManager", ["transport::SubserviceManager"], EventDispatcher, [
    {
        FAILED: 60123,
        STARTED: 60121,
        FINISHED: 60122,
    },
    ,
    ,
    ,
    {
        getDownloadedReportImagePath: [7,1,4],
        getPreviewThumbnail: [1,1],
        cleanupDownloadedReportImages: [0,1],
        downloadReportImage: [1,1],
        notifyGenerationFailed: [0,1],
        getReportImageLink: [1,1],
        getSectionThumbnail: [7,1,7,2],
        hasPreviewForSection: [2,1,3],
        notifyGenerationFinished: [0,1],
        getSectionThumbnails: [[7],1],
        getAllSectionImageLinks: [1,1],
        getDownloadedSectionImagePath: [7,1,7,4],
        getDownloadedSectionImagePathByIndex: [7,1,4,4],
        getGeneratedThumbnailDirectoryPath: [7,1],
        getGeneratedThumbnailPath: [7,1,3],
        downloadAllSectionImages: [1,1],
        notifyThumbnailGenerated: [0,1,3],
        notifyGenerationStarted: [0,1],
    },
    ,
    ,
]);
export default ThumbnailManager;
